import { render } from "./warning.vue?vue&type=template&id=23981881&scoped=true"
import script from "./warning.vue?vue&type=script&lang=js"
export * from "./warning.vue?vue&type=script&lang=js"

import "./warning.vue?vue&type=style&index=0&id=23981881&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23981881"]])

export default __exports__